import { useState, useEffect } from 'react'
import { motion } from "framer-motion";
import CardAd from './modals/CardAd';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { showToast } from '../../../../redux/slices/toastSlice';
import EmptyStateMyLoads from '../../../../Modals/empty list/EmptyList';
import { PiTruckLight } from "react-icons/pi";
import AdsService from '../../../../services/Ads';
import CargoService from '../../../../services/Cargo';
import { all } from 'axios';
import EditModal from './modals/EditModal';
import CustomInput from '../../../../Modals/filter modal/Input';
import MyAdsSkeleton from './modules/MyAdsSkeleton';
import { FaTrash } from 'react-icons/fa';
import { FiUpload } from 'react-icons/fi';
import { useRef } from 'react';
import FileService from '../../../../services/file';


export default function MyLoadsContent() {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const fileInputRef=useRef()

    const [expanded, setExpanded] = useState({});
    const [openEditModal, setOpenEditModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [loadingCity, setLoadingCity] = useState(false)
    const [loadingBtn, setLoadingBtn] = useState(false)

    const [title, setTitle] = useState(null)

    // car / product (id + display)
    const [carId, setCarId] = useState(null);
    const [carDisplay, setCarDisplay] = useState(null);
    const [cityId, setCityId] = useState(null);
    const [cityDisplay, setCityDisplay] = useState(null);

    const [year, setYear] = useState(null)


    const [type, setType] = useState(null)
    const [typeId,setTypeId]=useState(null)
    const [city, setCity] = useState(null)
    const [price, setPrice] = useState(null)
    const [desc, setDesc] = useState(null)
    const [images,setImages]=useState([])
    const [imagestoShow,setImagesToShow]=useState([])

    const [Data, SetOriginData] = useState([])
    const [ad, setAd] = useState({})

    const [errors, setErrors] = useState({
        title: false,
        car: false,
        year: false,
        type: false,
        city: false,
        price: false,
        desc: false,
    });

    //cities data
    async function getAllCityAndState() {
        try {
            setLoadingCity(true);


            const res = await CargoService.getAllState();
            const states = res?.data?.data ?? [];


            const fetches = states.map((st) =>
                CargoService.getAllCity({ state_id: st._id })
                    .then((r) => ({ state: st, citiesRes: r }))
                    .catch((err) => {
                        console.error("city fetch error for", st, err);
                        return { state: st, citiesRes: null };
                    })
            );

            const results = await Promise.all(fetches);
            const provincesWithCitiesArr = results.map(({ state, citiesRes }) => {
                const stateId = state?._id ?? state?.id ?? null;
                const stateName = state?.name ?? state?.title ?? String(stateId ?? "");

                const citiesArray = citiesRes?.data?.data ?? citiesRes?.data ?? citiesRes ?? [];


                const citiesNormalized = (Array.isArray(citiesArray) ? citiesArray : []).map((c) => {
                    if (typeof c === "string") {
                        return { name: c, value: c };
                    }
                    const cityId = c?._id ?? c?.id ?? c?.city_id ?? null;
                    const cityName = c?.name ?? c?.title ?? c?.city_name ?? String(cityId ?? "");
                    return { name: cityName, value: cityId ?? cityName };
                });

                return {

                    label: stateName,
                    value: stateId,
                    subItems: citiesNormalized,
                };
            });

            SetOriginData(provincesWithCitiesArr);
        }
        catch (err) {
            console.error("getAllCityAndState error:", err);

        } finally {
            setLoadingCity(false);
        }
    }

    useEffect(() => {
        getAllCityAndState();
    }, []);

    //car data
    const [carData, setCarData] = useState([])

    async function getAllCar() {
        try {
            const res = await CargoService.getAllCarType()
            const ids = res?.data?.data?.map((it) => { return it._id })
            const name = res?.data?.data?.map((it) => { return it.label + "-" + it?.name })

            setCarData(ids?.map((it, index) => { return { value: it, label: name[index] } }))

        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        getAllCar();
    }, []);

    const [yearData, setYearData] = useState([]);


    const [allAds, setAllAds] = useState([])

    async function getAllAds() {
        setLoading(true);
        try {
            const param = {
                // pagination:true,
                // page:1,
                // limit:400,
                // origin:filterItems[0].selectedVal?.city,
                // destination:filterItems[1].selectedVal?.city,
                // product:filterItems[2].selectedVal,
                // car:filterItems[3].selectedVal,
                // type:filterItems[4].selectedVal
            }
            console.log("param:", param)
            const res = await AdsService.myAds(param)
            setAllAds(res?.data?.data)
            console.log("all ads:", res?.data?.data)
        } catch (err) {
            console.log("Error fetching ads:", err)
        }
        finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        getAllAds()
    }, [])



    // console.log("allAds:", allAds)

    async function editMyAd() {
        setLoadingBtn(true)
        try {
            const body = {
                "id": ad?._id,
                "car": carId,
                "year": year,
                "type": typeId,
                "city": cityId,
                "price": price,
                "productionYear": year,
                "description":desc,
                "title":title
            }
            console.log("Editing ad body:", body)
            const res = await AdsService.updateAd(body)
            console.log("Editing ad response:", res)
            if (res.status == 200) {
                getAllAds()
                dispatch(showToast({ message: "بار شما با موفقیت ویرایش شد", type: "success" }))
            }
        } catch (err) {
            console.log(err)
            dispatch(showToast({ message: "خطا در ویرایش بار", type: "error" }))
           
        } finally {
            setTimeout(() => {
                setOpenEditModal(false)
            }, (200));

            setLoadingBtn(false)

        }
    }

    useEffect(() => {
        if (!ad) return;
        setCarId(ad?.car?._id || null);
        setCarDisplay(ad?.car ? ad?.car?.label + " - " + ad?.car?.name : null);
        setTitle(ad?.title || "");
        setDesc(ad?.description || "");
        setPrice(ad?.price || "");
        setType(ad?.type === "sales" ? "فروش" : "اجاره‌");
        setTypeId(ad?.type)
        setCityId(ad?.city?._id || null);
        setCityDisplay(ad?.city?.name || null);
        setYear(ad?.productionYear)
        setImages(ad?.image)
        setImagesToShow(ad?.image)
    }, [ad]);



    function handleDelImage(e,id){
        e.stopPropagation()
        setImages(images?.filter((it)=>it?._id!=id))
        setImagesToShow(images?.filter((it)=>it?._id!=id))
    }

    useEffect(() => {
        getAllAds()
    }, [])
    const [loadingImage,setLoadingImage]=useState(false)


    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setLoadingImage(true)
        
        try {
            setImagesToShow((prev) => [...(prev || []), {_id:file}])
          const res = await FileService.uploadFile({file:file});
      
          const newFile = res._id ?? res;
          if (!newFile){
            dispatch(showToast({message:"خطا در آپلود تصویر",type:"error"}))
          }
          console.log(file)
          dispatch(showToast({message:"تصویر با موفقیت بارگذاری شد",type:"success"}))

          setImages((prev) => [...(prev || []), newFile]);
          setImagesToShow((prev) => [...(prev || []), {_id:file}])
          e.target.value = "";
        } catch (err) {
            console.log(err)
            dispatch(showToast({message:"خطا در آپلود تصویر",type:"error"}))

        }finally{
            setLoading(false)
        }
      };

    const openFileDialog = () => {
        if (fileInputRef.current) fileInputRef.current.click();
      };

  
    if (loading) return (
        <div className="w-full flex flex-col gap-10 lg:h-[calc(100vh-10rem)]  overflow-y-auto  py-10 lg:px-10 px-5">
            <MyAdsSkeleton count={6} />
        </div>

    )


    
    return (
        <>
            {/* ***********edit modal************* */}
            <EditModal
                loading={loadingBtn}
                isOpen={openEditModal}
                onClose={() => setOpenEditModal(false)}
                onSave={editMyAd}
                title={title}
            >
            <motion.div className="flex flex-col justify-start items-center gap-4 w-full h-full">

            <motion.div className="flex justify-start items-center gap-3 w-full max-h-auto py-1 overflow-x-auto">
            {imagestoShow?.map((it, index) => (
                <motion.div
                    key={it._id ?? index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.2, delay: index * 0.06 }}
                    className="flex relative min-w-[200px] transition-all bg-white/5 bg-opacity-35 duration-200 hover:scale-105 justify-center items-center gap-8 px-6 py-6  h-auto border-[1px] border-spacing rounded-md shadow-xl"
                >
                    <motion.img
                    src={it?.path ? `https://barsaraa.maksiran.ir${it.path}` :it?._id}
                    alt={`image-${index}`}
                    className="max-w-full object-cover rounded-md"
                    />
                    <FaTrash
                    onClick={(e) => handleDelImage(e, it?._id)}
                    size={15}
                    className="text-red-500 absolute top-1 right-3 cursor-pointer"
                    aria-label="حذف تصویر"
                    title="حذف تصویر"
                    />
                </motion.div>
                ))}

                <div
                onClick={openFileDialog}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") openFileDialog();
                }}
                className="flex flex-col p-2 border-[1px] border-gray-400 justify-center items-center gap-8 shadow-md min-w-[200px] h-[200px] px-6 py-6 rounded-md cursor-pointer"
                aria-label="آپلود عکس"
                >
                <img
            
                    className="max-w-[100px] object-cover rounded-lg"
                />
                <FiUpload className="text-gray-400" size={28} />
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={handleFileChange}
                />
                <span className="text-xs text-gray-500 mt-2">{`عکس ${images?.length + 1}`}</span>
                </div>
                
    
            </motion.div>

                {/* cards grid */}
                <motion.div className="grid grid-cols-1 sm:flex sm:flex-wrap gap-8 w-full h-full">
                    <CustomInput
                        error={errors.title ? "عنوان را وارد کنید" : false}
                        label="عنوان آگهی"
                        items={title}
                        setVal={setTitle}
                        val={title}
                    />
                    <CustomInput
                        error={errors.car ? "مدل خودرو را وارد کنید" : false}
                        label="مدل خودرو"
                        items={carData}
                        setVal={setCarId}
                        val={carDisplay}
                        type={"option"}
                    />
                    <CustomInput
                        error={errors.year ? "سال تولید را وارد کنید" : false}
                        label="سال تولید"
                        items={Array.from({ length: 31 }, (_, i) => {
                            const year = 1375 + i;
                            return { label: String(year), value: String(year) };
                        })}
                        setVal={setYear}
                        val={year}
                        type={"option"}
                    />

                    <CustomInput
                        error={errors.car ? "نوع معامله را وارد کنید" : false}
                        label="نوع معامله"
                        items={[
                            { label: "فروش", value: "sales" },
                            { label: "اجاره‌", value: "rent" },
                        ]}
                        setVal={setTypeId}
                        val={type}
                        type={"option"}
                    />
                    <CustomInput
                        error={errors.city ? "شهر را وارد کنید" : false}

                        label="شهر"
                        items={Data}
                        setVal={setCityId}
                        val={cityDisplay}
                        type={"option"}

                    />
                    <CustomInput
                        error={errors.price ? "قیمت را وارد کنید" : false}
                        label="قیمت"
                        items={price}
                        setVal={setPrice}
                        val={price}
                        type={"number"}
                    />
                    <CustomInput
                        error={errors.desc ? "توضیحات را وارد کنید" : false}
                        label="توضیحات"
                        items={desc}
                        setVal={setDesc}
                        val={desc}
                        type={"text"}
                    />


                </motion.div>
            </motion.div>

            </EditModal>



            {
                allAds?.length == 0 ?
                    <>
                        <EmptyStateMyLoads
                            icon={PiTruckLight}
                            colorContent="text-special"
                            title="آگهی برای نمایش وجود ندارد"
                            subtitle="تاکنون آگهی ثبت نکرده اید."
                            onCta={() => { navigate("/registerAds") }}
                            ctaText="افزودن آگهی جدید" >


                        </EmptyStateMyLoads>
                    </>
                    :

                    <div className="w-full flex flex-col gap-10 lg:h-[calc(100vh-10rem)]  overflow-y-auto  py-10 lg:px-10 px-5">
                        <CardAd setIsEditOpen={setOpenEditModal} setAds={setAd}></CardAd>
                    </div>
            }
        </>
    )
}